var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImplant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37624 24.5083L3.1578 23.7337C2.6017 21.7476 1.90657 19.9005 1.17171 18.0137C0.752053 16.8136 0.537193 15.5513 0.536151 14.2799C0.494572 12.4701 0.933174 10.6815 1.80728 9.09623C2.37171 8.13061 3.18171 7.33159 4.15497 6.78043C5.12822 6.22926 6.23 5.94557 7.34842 5.95818C7.72475 5.91897 8.10416 5.91897 8.4805 5.95818L13.6642 6.99099L18.7684 6.09722C19.1448 6.05801 19.5242 6.05801 19.9005 6.09722C21.0166 6.08462 22.1163 6.36615 23.089 6.91353C24.0617 7.4609 24.8732 8.25484 25.4416 9.21539C25.8379 9.92277 26.1449 10.6766 26.3553 11.4597C26.9399 13.6677 26.843 16.0009 26.0772 18.1528C25.3622 20.1389 24.6274 22.125 24.0911 24.111L23.9123 24.687",
    stroke: "#A0A09F",
    strokeWidth: 1.13132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8528 24.4885H3.37622V32.6315H23.8528V24.4885Z",
    stroke: "#A0A09F",
    strokeWidth: 1.13132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48169 32.6315L8.28202 34.7566V48.6592C8.28093 49.1648 8.38652 49.6649 8.59186 50.127C8.7972 50.589 9.09774 51.0025 9.47374 51.3405L13.6047 55.0147",
    stroke: "#A0A09F",
    strokeWidth: 1.13132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7475 32.6315L18.9471 34.7566V48.6592C18.9495 49.1669 18.8427 49.6693 18.6336 50.1319C18.4245 50.5946 18.1182 51.0068 17.7356 51.3405L13.6045 55.0147",
    stroke: "#A0A09F",
    strokeWidth: 1.13132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28174 34.7963L13.386 35.8688C15.2214 36.2608 16.9666 36.9953 18.53 38.0337L18.947 38.3117",
    stroke: "#A0A09F",
    strokeWidth: 1.13132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28174 39.9204L13.3661 40.973C15.3472 41.3866 17.2377 42.1536 18.947 43.2371",
    stroke: "#A0A09F",
    strokeWidth: 1.13132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28174 44.965L13.3661 46.0177C14.2819 46.2103 15.1792 46.4828 16.0474 46.832C17.0593 47.2187 18.0305 47.7043 18.947 48.2818",
    stroke: "#A0A09F",
    strokeWidth: 1.13132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36133 49.4338L13.3662 50.4666C14.7064 50.7511 16.007 51.198 17.2391 51.7972",
    stroke: "#A0A09F",
    strokeWidth: 1.13132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47461 27.0903V29.414H14.2005",
    stroke: "#A0A09F",
    strokeWidth: 1.13132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2004 10.4071L17.9144 9.59283C18.7158 9.40196 19.5542 9.43431 20.3385 9.68642C21.1228 9.93852 21.8231 10.4008 22.3632 11.0229L22.6016 11.3008C23.2172 12.1854 23.537 13.2422 23.5152 14.3197",
    stroke: "#A0A09F",
    strokeWidth: 1.13132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.529,
    height: 60.9729,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplant);
export default __webpack_public_path__ + "static/media/implant.be27b17477007a6244c47365cd44e62c.svg";
export { ForwardRef as ReactComponent };